var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("developer.application_setting"),
        visible: _vm.dialogVisible,
        width: "800px",
        top: "5vh",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "custom-class": "merchant-app-detail-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c("div", { staticClass: "merchant-application-detail" }, [
        _c("div", { staticClass: "application-detail-switch" }, [
          _c(
            "div",
            { staticClass: "grid-content bg-purple-light" },
            [
              _c(
                "el-row",
                { staticClass: "switch-class" },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "grid-content bg-purple-light" }, [
                      _c(
                        "p",
                        { staticClass: "setting-title" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("developer.shared_application_setting")
                              ) +
                              " "
                          ),
                          _c(
                            "el-tooltip",
                            { attrs: { placement: "top" } },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: { width: "300px" },
                                  attrs: { slot: "content" },
                                  slot: "content",
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "tips.shared_application_setting_tips"
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _c("svg-icon", {
                                staticClass: "icon-question-tip",
                                attrs: { "icon-class": "icon-blue-question" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      [
                        _c("el-switch", {
                          attrs: {
                            "active-value": 1,
                            "inactive-value": 2,
                            "active-color": "#67C23A",
                            "inactive-color": "#F56C6C",
                            disabled: "",
                          },
                          model: {
                            value: _vm.form.share_public_key_status,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "share_public_key_status", $$v)
                            },
                            expression: "form.share_public_key_status",
                          },
                        }),
                      ],
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "application-detail-application" },
          [
            _c(
              "el-row",
              [
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "grid-content bg-purple" }, [
                    _c("p", { staticClass: "setting-title" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("developer.application_information")) +
                          " "
                      ),
                    ]),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 16 } }, [
                  _c(
                    "div",
                    { staticClass: "grid-content bg-purple-light" },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 8 } }, [
                            _c(
                              "div",
                              { staticClass: "grid-content bg-purple" },
                              [
                                _c("p", { staticClass: "setting-key" }, [
                                  _vm._v("AppId:"),
                                ]),
                              ]
                            ),
                          ]),
                          _c("el-col", { attrs: { span: 16 } }, [
                            _c(
                              "div",
                              { staticClass: "grid-content bg-purple" },
                              [
                                _c("p", { staticClass: "setting-value" }, [
                                  _vm._v(_vm._s(_vm.form.app_id)),
                                ]),
                              ]
                            ),
                          ]),
                          _c("el-col", { attrs: { span: 3 } }, [
                            _c("div", {
                              staticClass: "grid-content bg-purple",
                            }),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "application-detail-webhook" },
          [
            _c(
              "el-row",
              [
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "grid-content bg-purple" }, [
                    _c("p", { staticClass: "setting-title" }, [
                      _vm._v("Webhook"),
                    ]),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 16 } }, [
                  _c(
                    "div",
                    { staticClass: "grid-content bg-purple-light" },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 6 } }, [
                            _c(
                              "div",
                              { staticClass: "grid-content bg-purple" },
                              [
                                _c("p", { staticClass: "setting-key" }, [
                                  _vm._v("Pay out:"),
                                ]),
                              ]
                            ),
                          ]),
                          _c("el-col", { attrs: { span: 18 } }, [
                            _c(
                              "div",
                              { staticClass: "grid-content bg-purple" },
                              [
                                _c("el-input", {
                                  staticClass: "search-frame",
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "merchant.notice_webhook"
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.notice_webhook,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "notice_webhook", $$v)
                                    },
                                    expression: "form.notice_webhook",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "application-detail-apiKey" },
          [
            _c(
              "el-row",
              [
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "grid-content bg-purple" }, [
                    _c("p", { staticClass: "setting-title" }, [
                      _vm._v("API Key"),
                    ]),
                    _c(
                      "div",
                      { staticStyle: { width: "80%", "margin-top": "20px" } },
                      [
                        _c("p", { staticClass: "setting-title-dec" }, [
                          _vm._v(_vm._s(_vm.$t("tips.public_key_introduce"))),
                        ]),
                      ]
                    ),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 16 } }, [
                  _c(
                    "div",
                    { staticClass: "grid-content bg-purple-light" },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 6 } }, [
                            _c(
                              "div",
                              { staticClass: "grid-content bg-purple-light" },
                              [
                                _c("p", { staticClass: "setting-key" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("developer.public_key")) +
                                      ":"
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                          _c("el-col", { attrs: { span: 18 } }, [
                            _c(
                              "div",
                              { staticClass: "grid-content bg-purple-light" },
                              [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    rows: 8,
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.form.public_key,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "public_key", $$v)
                                    },
                                    expression: "form.public_key",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "application-detail-ip" },
          [
            _c(
              "el-row",
              [
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "grid-content bg-purple" }, [
                    _c(
                      "p",
                      { staticClass: "setting-title" },
                      [
                        _vm._v(_vm._s(_vm.$t("developer.ip_white_list")) + " "),
                        _c(
                          "el-tooltip",
                          { attrs: { placement: "top" } },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: { width: "300px" },
                                attrs: { slot: "content" },
                                slot: "content",
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("tips.ip_white_paycools_introduce")
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _c("svg-icon", {
                              staticClass: "icon-question-tip",
                              attrs: { "icon-class": "icon-blue-question" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 16 } }, [
                  _c(
                    "div",
                    { staticClass: "grid-content bg-purple-light" },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 6 } }, [
                            _c("p", { staticClass: "setting-key" }, [
                              _vm._v(
                                _vm._s(_vm.$t("developer.ip_address")) + ":"
                              ),
                            ]),
                          ]),
                          _c("el-col", { attrs: { span: 16 } }, [
                            _c(
                              "div",
                              { staticClass: "grid-content bg-purple-light" },
                              [
                                _c("p", { staticClass: "setting-value" }, [
                                  _vm._v(_vm._s(_vm.form.white_ip)),
                                ]),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("components.cancel")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: _vm.listLoading },
              on: { click: _vm.onClickSubmitBtn },
            },
            [_vm._v(" " + _vm._s(_vm.$t("components.submit")) + " ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }